module.exports = __webpack_public_path__ + "media/images/plan-grid2-216a6fcc96495f9aaf539230c8cff22a.jpg";